import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SliderContentGetAll } from '../../services';

export const fetchSliderContentGetAll = createAsyncThunk(
    'sliderContentGetAll/fetchSliderContentGetAll',
    async () => {
        const response = await SliderContentGetAll()
        return response.result
    }
);

const sliderContentGetAllSlice = createSlice({
    name: 'sliderContentGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderContentGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderContentGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderContentGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderContentGetAllSlice.reducer;
